//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import ModalActions from '../../Actions/modal';
import MagicLinkForm from '../../SignIn/components/MagicLinkForm.react';
import SessionActions from '../../Actions/session';
import Constants from '../../constants';

function _onSubmit() {
  ModalActions.closeModal(Constants.MAGIC_LINK_MODAL);
  ModalActions.openModal(Constants.MAGIC_LINK_SENT_MODAL);
}

function _showLoginModal() {
  SessionActions.removeLoginError();
  ModalActions.closeModal(Constants.MAGIC_LINK_MODAL);
  ModalActions.openModal(Constants.LOGIN_MODAL);
}

function MagicLinkModal() {
  return (
    <MagicLinkForm
      onSubmit={_onSubmit}
      showSignIn={_showLoginModal}
    />
  );
}

export default modal<{}>(MagicLinkModal, {
  name: Constants.MAGIC_LINK_MODAL,
  className: 'login-modal magiclink-sent',
});
